<YCPage query={pageQuery}>
  <div class="page-content">
    <div class="promo-header">
      <div class="promo-banner" on:click={() => dropIsLive && f7.views.main.router.navigate('/pages/en/DropLobby')}>
        <img src="../static/images/promo_banner.jpg" alt="Promo Banner" />
      </div>
      <div class="promo-buttons">
        <div class="promo-button promo-button-instructions" on:click={() => instructionsPopupOpen = true}><img src="../static/images/icon_instructions.png" alt="Instructions" />Drop Instructions</div>
        <a class="promo-button promo-button-schedule external" href="https://www.leedsunited.com/en/terms-and-conditions" target="_blank"><img src="../static/images/icon_schedule.png" alt="Terms and Conditions" />Terms &amp; Conditions</a>
      </div>
      {#if upcomingDrop}
        <div class="promo-left-text">ENTER TO WIN</div>
        <div class="promo-top-left-text">{formattedDate}</div>
        <div class="promo-top-right-text">{formattedYear}</div>
        <div class="promo-right-text">{formattedTime}</div>
      {/if}
    </div>
    <div class="section-header">UPCOMING DROPS</div>
    <div class="upcoming-carousel hide-scrollbar">
      <div class="carousel-track">
        {#each upcomingDrops as drop}
          <div class="carousel-item">
            <div class="drop-card" style={`background-image: url('${drop.ThumbnailUrl}')`} on:click={() => isDropLive(drop) && f7.views.main.router.navigate('/pages/en/DropLobby')}>
              <div class="drop-date-pill">
                <div class="drop-date-day">{formatDay(drop.StartTime)}</div>
                <div class="drop-date-month">{formatMonth(drop.StartTime)}</div>
              </div>
              <div class="drop-time-pill">
                <div class="drop-time">{formatTime(drop.StartTime)}</div>
              </div>
              <div class="drop-info">
                <div class="drop-title">{drop.Name}</div>
                <div class="drop-date">{formatFullDate(drop.StartTime)}</div>
              </div>
              <div class="enter-drop-button">
                <img src="../static/images/icon_arrow_right.svg" alt="Enter Drop" />
              </div>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>

  <InstructionsPopup
    bind:opened={instructionsPopupOpen}
    title="How to Participate"
    steps={instructionSteps}
  />
</YCPage>

<style>.page-content {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 15vh;
  position: relative;
  background-color: white;
  background-image: url('../static/images/winter-bg.jpg');
  background-position-y: 30vh;
  background-size: cover;
}

.page-content > .promo-header {
  position: relative;
  width: 100%;
  overflow: hidden;
  font-family: "PT Mono", "Roboto Mono", monospace;
}

.page-content > .promo-header > .promo-banner {
  width: 100%;
  height: auto;
}

.page-content > .promo-header > .promo-banner > img {
  display: block;
  width: 100%;
  height: auto;
}

.page-content > .promo-header > .promo-left-text {
  position: absolute;
  top: 50%;
  left: 5%;
  font-size: 4cqw;
  color: black;
  font-weight: bold;
  transform: rotate(-90deg) translateX(-50%);
  transform-origin: left center;
}

.page-content > .promo-header > .promo-top-left-text {
  position: absolute;
  top: 8%;
  left: 11%;
  font-size: 4cqw;
  color: black;
  font-weight: bold;
}

.page-content > .promo-header > .promo-top-right-text {
  position: absolute;
  top: 8%;
  right: 11%;
  font-size: 4cqw;
  color: black;
  font-weight: bold;
}

.page-content > .promo-header > .promo-right-text {
  position: absolute;
  top: 29%;
  right: 5%;
  font-size: 4cqw;
  color: black;
  font-weight: bold;
  transform: rotate(90deg);
  transform-origin: right center;
}

.page-content > .promo-header > .promo-buttons {
  width: 100%;
  background-color: #FFCC00;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  grid-gap: 2cqw;
  gap: 2cqw;
  transform: translateY(-1px);
  padding-bottom: 5cqw;
  border-bottom-left-radius: 35px;
  border-bottom-right-radius: 35px;
}

.page-content > .promo-header > .promo-buttons > .promo-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 2.5cqw;
  color: white;
  text-decoration: none;
  background-color: black;
  font-weight: bold;
  border-radius: 10cqw;
  padding: 1.0cqw;
  width: 40cqw;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif;
}

.page-content > .promo-header > .promo-buttons > .promo-button > img {
  width: 8cqw;
  height: auto;
  margin-right: 2cqw;
}

.page-content > .section-header {
  font-size: 6cqw;
  font-weight: bold;
  margin-top: 4cqw;
  margin-bottom: 2cqw;
  color: #283583;
  margin-left: 5%;
}

.page-content > .upcoming-carousel {
  width: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-left: 5%;
  padding-bottom: 5cqw;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */

.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.page-content > .upcoming-carousel > .carousel-track {
  padding-left: 5%;
  display: flex;
  flex-direction: row;
  grid-gap: 4cqw;
  gap: 4cqw;
}

.page-content > .upcoming-carousel > .carousel-track > .carousel-item {
  flex: 0 0 auto;
  width: 60cqw;
  height: auto;
  scroll-snap-align: start;
}

.drop-card {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.drop-card::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));
  border-radius: 20px;
  pointer-events: none;
}

.drop-card > .drop-date-pill {
  position: absolute;
  top: 5%;
  left: 5%;
  background-color: white;
  border-radius: 10px;
  padding: 2cqw 3cqw;
  color: black;
  text-align: center;
}

.drop-card > .drop-date-pill > .drop-date-day {
  font-size: 6cqw;
  font-weight: bold;
  line-height: 1.2;
}

.drop-card > .drop-date-pill > .drop-date-month {
  font-size: 3cqw;
  line-height: 1;
}

.drop-card > .drop-time-pill {
  position: absolute;
  top: 5%;
  right: 5%;
  -webkit-backdrop-filter: blur(5.19px);
  backdrop-filter: blur(5.19px);
  border-radius: 35px;
  background: linear-gradient(172.65deg, rgba(125, 163, 200, 0.6), rgba(255, 255, 255, 0));
  padding: 2cqw 3cqw;
  color: white;
}

.drop-card > .drop-time-pill > .drop-time {
  font-size: 3.5cqw;
  line-height: 1;
}

.drop-card > .drop-info {
  position: absolute;
  bottom: 6%;
  left: 5%;
  color: white;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);
}

.drop-card > .drop-info > .drop-title {
  font-size: 4cqw;
  font-weight: bold;
  line-height: 1;
}

.drop-card > .drop-info > .drop-date {
  font-size: 2.5cqw;
  font-weight: bold;
}

.drop-card > .enter-drop-button {
  position: absolute;
  bottom: 8%;
  right: 5%;
  width: 7cqw;
  height: 7cqw;
  background-color: rgba(255, 204, 0, 0.9);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.drop-card > .enter-drop-button > img {
  width: 6cqw;
  height: auto;
}</style>


<script lang='ts'>import YCPage from '../components/YCPage.svelte';
import { getDeviceId } from '../js/stores.js';
import { onMount } from 'svelte';
import { f7 } from 'framework7-svelte';
import InstructionsPopup from '../components/InstructionsPopup.svelte';
const pageQuery = {
    backButton: 'false',
    round: 'previous'
};
let instructionsPopupOpen = false;
const instructionSteps = [
    {
        title: 'Stay Tuned',
        description: 'Watch for upcoming drop announcements. Each drop has a specific date and time when it becomes active.'
    },
    {
        title: 'Enter the Drop',
        description: 'When a drop goes live, tap the enter button on the drop card to join. You must be present during the active time window.'
    },
    {
        title: 'Stay on the Page',
        description: 'Keep the drop page open during the countdown. Winners are randomly selected from active participants.'
    },
    {
        title: 'Win Exclusive Items',
        description: 'If you\'re selected as a winner, you\'ll receive a notification with instructions on how to claim your prize!'
    }
];
let dropIsLive = false;
let upcomingDrop = null;
let upcomingDrops = [];
let formattedDate = '';
let formattedYear = '';
let formattedTime = '';
const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
const monthNamesFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
function formatDay(timestamp) {
    return new Date(timestamp).getDate().toString();
}
function formatMonth(timestamp) {
    return monthNames[new Date(timestamp).getMonth()];
}
function formatTime(timestamp) {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    return `${hours}:${minutesStr} ${ampm}`;
}
function formatFullDate(timestamp) {
    const date = new Date(timestamp);
    const dayName = dayNames[date.getDay()];
    const month = monthNamesFull[date.getMonth()];
    const day = date.getDate();
    const time = formatTime(timestamp);
    return `${dayName} ${month} ${day}, ${time.toLowerCase()}`;
}
function isDropLive(drop) {
    const now = new Date();
    const startDate = new Date(drop.StartTime);
    const endDate = new Date(drop.EndTime);
    return now >= startDate && now <= endDate;
}
onMount(async () => {
    try {
        const appId = `${CONFIG.league.toUpperCase()}_${CONFIG.tricode.toUpperCase()}`;
        const service = `drops-${CONFIG.environment}-${CONFIG.tricode}-${CONFIG.league}`;
        const response = await fetch(`https://${service}.yinzcam.com/drops/upcoming?application=${appId}`, { headers: { 'X-YinzCam-DeviceId': getDeviceId() } });
        const data = await response.json();
        if (data.UpcomingDrops && data.UpcomingDrops.length > 0) {
            upcomingDrops = data.UpcomingDrops;
            upcomingDrop = data.UpcomingDrops[0];
            // Format the date from StartTime (milliseconds timestamp)
            const date = new Date(upcomingDrop.StartTime);
            // Format: "DEC 15"
            formattedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
            // Format: "2025"
            formattedYear = date.getFullYear().toString();
            // Format: "6:00 PM"
            formattedTime = formatTime(upcomingDrop.StartTime);
            const endDate = new Date(upcomingDrop.EndTime);
            const now = new Date();
            dropIsLive = now >= date && now <= endDate;
        }
    }
    catch (error) {
        console.error('Failed to fetch upcoming drops:', error);
    }
});
</script>
